module.exports = __webpack_public_path__ + "static/img/8.af90dc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/sp/8.png
// module id = o6SO
// module chunks = 0